import React from 'react';
import classes from './HomePage.module.scss';
import { useNavigate } from 'react-router';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import Mainbanner from '../../components/MainBanner/MainBanner';

import SliderComponent from '../../components/SliderComponent/SliderComponent';
import GameCarousel from '../../components/SliderComponent/GameCarousel';

import GamesComponent from '../../components/GamesComponent/GamesComponent';
import tourneLogo from '../../assets/gamesImagesDemo/tourneLogo.png';

import GameStudio from '../../components/GameStudio/GameStudio';

import sportBettingBack from '../../assets/GamesBackImages/sportBetting.png';
import lotteryBg from '../../assets/GamesBackImages/lottery-bg-homepage.jpg';
import poolbettinghomepage from '../../assets/GamesBackImages/pool-betting-homepage-.jpg';

import scratcgLogo from '../../assets/MainBannerImages/Cards.png';
import scratchTitle from '../../assets/MainBannerImages/ScratchandWin.png';
import scratchtext from '../../assets/MainBannerImages/scratchtext.png';
import BingoAlphabet from '../../assets/ScratchImages/bingoActiveLogo.png';
import SportDeChance from '../../assets/ScratchImages/new-sport-logo.png';
import TourneDeChance from '../../assets/ScratchImages/tournedechanceLogo.png';
import fruitLogo from '../../assets/ScratchImages/new-fruit-logo.png';
import luckyLogo from '../../assets/ScratchImages/lucky7-logo.png';
import dmLogo from '../../assets/ScratchImages/DMLogo.png';
import bingoSafaryLogo from '../../assets/ScratchImages/bingo-safari.png';
import CafmainLogo from '../../assets/ScratchImages/Caf-mainLogo.png';

function HomePage() {
  const navigate = useNavigate();
  const banners = [
    <Mainbanner
      BackImage="jackPotBg"
      TitleIcon="jackPot"
      lotteryLap="LotteryLaptop"
      link="/lotteryGames"
    />,
    <Mainbanner
      BackImage="scratchBg"
      logoIcon="scratchIcon"
      LogoImage={scratcgLogo}
      titlebannerImage1={scratchTitle}
      TitleIcon="scratchTitle"
      titleBannerImage2={scratchtext}
      link="/scratchGames"
    />,
    <Mainbanner
      BackImage="sportsBettingBg"
      TitleIcon="sportsBetting"
      link="/sportsbetting"
    />,
  ];

  const gamesData = [
    <GamesComponent
      backGroundImage="CafImage"
      LogoIcon={CafmainLogo}
      gameName="Caf Game"
      onClick={() => navigate('/caf')}
    />,
    <GamesComponent
      backGroundImage="luckyImage"
      LogoIcon={luckyLogo}
      gameName="Lucky 7"
      onClick={() => navigate('/lucky7')}
    />,
    <GamesComponent
      backGroundImage="millionaireImage"
      LogoIcon={dmLogo}
      gameName="Double Millionaire"
      onClick={() => navigate('/double-millionaire')}
    />,
    <GamesComponent
      backGroundImage="bingosafaryImage"
      LogoIcon={bingoSafaryLogo}
      gameName="Bingo Safari"
      onClick={() => navigate('/bingo-safari')}
    />,
    <GamesComponent
      backGroundImage="fruitsImage"
      LogoIcon={fruitLogo}
      gameName="Fruit De Chance"
      onClick={() => navigate('/fruit-de chance')}
    />,
    <GamesComponent
      backGroundImage="bingoAlphabet"
      LogoIcon={BingoAlphabet}
      gameName="Bingo Alphabet"
      onClick={() => navigate('/bingo-alphabet')}
    />,
    <GamesComponent
      backGroundImage="sportDeChance"
      LogoIcon={SportDeChance}
      gameName="Sport De Chance"
      onClick={() => navigate('/sport-de-Chance')}
    />,
    <GamesComponent
      backGroundImage="tourneDeChance"
      LogoIcon={TourneDeChance}
      gameName="Tourne De Chance"
      onClick={() => navigate('/tourne-de-chance')}
    />,
  ];

  const gamesDataPopular = [
    {
      backGroundImage: 'chanceImage',
      LogoIcon: tourneLogo,
      onClick: () => (window.location.href = '/tourne-de-chance'),
    },
    {
      backGroundImage: 'sportsbetting',
      LogoIcon: null,
      onClick: () => (window.location.href = '/sportsbetting'),
    },
    {
      backGroundImage: 'keno580',
      onClick: () => (window.location.href = '/lotteryGames'),
    },
  ];

  const gameStudiosData = [
    {
      backGroundImage: 'sportingBetting',
      title: 'Sports Betting',
      paragraph:
        'Experience top-tier sports betting with real-time odds, live updates, and seamless wagering. Bet on your favorite sports with confidence and enjoy a thrilling, secure, and user-friendly platform.',
      rightData: 'rightData',
      imageBack: sportBettingBack,
      onClick: () => (window.location.href = '/sportsbetting'),
    },
    {
      backGroundImage: 'lotteryStudio',
      title: 'Lottery Studio',
      paragraph:
        'Our Lottery Studio is an innovative, customizable platform for creating, launching, and managing online lottery games. With a user-friendly interface, it enables businesses to design traditional and instant win games, manage player accounts, and integrate various payment systems. Featuring certified random number generators (RNGs) and advanced encryption, it ensures fair and secure gameplay. The platform offers powerful analytics, scalability, and integration with third-party services for enhanced marketing and engagement. Through our demo website, businesses can explore these features firsthand and see how the Lottery Studio can help launch successful, compliant lottery games for global audiences.',
      imageBack: lotteryBg,
      onClick: () => (window.location.href = '/lotteryGames'),
    },
    {
      backGroundImage: 'PoolBetting',
      title: 'Pool Betting',
      paragraph:
        'Experience the thrill of Pool Betting with real soccer & basketball matches, shared prize pools, and big wins!',
      rightData: 'rightData',
      imageBack: poolbettinghomepage,
      onClick: () => (window.location.href = '/footycash'),
    },
  ];

  return (
    <>
      <Header />
      <div className={classes.sliderCont}>
        <SliderComponent items={banners} />
      </div>
      <div className="container">
        <span className={classes.titlePopular}>Popular Games</span>
        <span className={classes.subTitlePopular}>
          Crafted with a player-first obsession, we redefine authenticity with
          every click, swipe, and spin.{' '}
        </span>
        <div className={classes.popularImages}>
          {gamesDataPopular.map((game, index) => (
            <GamesComponent
              key={index}
              backGroundImage={game.backGroundImage}
              LogoIcon={game.LogoIcon}
              onClick={game.onClick}
            />
          ))}
        </div>
      </div>
      <div className={classes.allGamesDetails}>
        {gameStudiosData.map((studio, index) => (
          <GameStudio
            key={index}
            backGroundImage={studio.backGroundImage}
            title={studio.title}
            paragraph={studio.paragraph}
            rightData={studio.rightData}
            imageBack={studio.imageBack}
            onClick={studio.onClick}
          />
        ))}
      </div>

      <div className="container">
        <div className={classes.titleBtnScratch}>
          <span className={classes.scratchTitle}>Scratch & Chance Games</span>
          <button
            className={classes.btnUssdScratch}
            onClick={() => navigate('/ussdGames')}
          >
            Check out USSD Scratch & Chance
          </button>
        </div>
        <div>
          <GameCarousel items={gamesData} />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default HomePage;
